import { css } from "styled-components";
import ofc from "../../settings/variables";

// Estilos del calendario "Cronograma" del crédito.
// Mobile-first: pensado para el ancho del modal en celular, sin scroll
// horizontal y con un tamaño mínimo de fuente de 11px.
const styles = css`
  display: block;
  padding: ${ofc.s2}em 0 ${ofc.s3}em;
  color: ${ofc.textColor};
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .cronograma-vacio {
    text-align: center;
    color: ${ofc.bgDark};
    padding: 2em 0;
    font-size: ${ofc.x0};
  }

  .resumen-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    margin-bottom: 10px;
  }

  .resumen-item {
    background: ${ofc.bgLight};
    border-radius: 8px;
    padding: 6px 4px;
    text-align: center;
  }

  .resumen-item-full {
    grid-column: 1 / -1;
  }

  .resumen-item .label {
    display: block;
    font-size: 11px;
    color: ${ofc.bgDark};
    line-height: 1.3;
  }

  .resumen-item .valor {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: ${ofc.textColor};
    line-height: 1.4;
  }

  .leyenda {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 10px;
    font-size: 11px;
    color: ${ofc.textColor};
  }

  .leyenda-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .punto {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
    flex: none;
  }
  .punto.estado-pagada {
    background: ${ofc.primary};
  }
  .punto.estado-parcial {
    background: ${ofc.yellow};
  }
  .punto.estado-sin_abono {
    background: ${ofc.red};
  }
  .punto.estado-pendiente {
    background: #fff;
    border: 1px solid ${ofc.inputBorder};
  }

  .dias-semana-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    font-size: 11px;
    color: ${ofc.bgDark};
    margin-bottom: 4px;
  }

  .mes-header {
    font-size: 12px;
    font-weight: 700;
    color: ${ofc.textColor};
    margin: 8px 0 4px;
    text-transform: lowercase;
  }

  .semana-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 3px;
    margin-bottom: 3px;
    align-items: stretch;
  }

  .dia-celda {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 3px 1px 4px;
    position: relative;
    overflow: hidden;
  }

  .dia-celda.con-cuota {
    border: 1px solid transparent;
    justify-content: flex-start;
  }

  .dia-celda.con-cuota.estado-pagada {
    background: rgba(26, 179, 148, 0.12);
    border-color: rgba(26, 179, 148, 0.35);
  }
  .dia-celda.con-cuota.estado-parcial {
    background: rgba(255, 201, 55, 0.2);
    border-color: rgba(255, 201, 55, 0.55);
  }
  .dia-celda.con-cuota.estado-sin_abono {
    background: rgba(225, 89, 105, 0.12);
    border-color: rgba(225, 89, 105, 0.35);
  }
  .dia-celda.con-cuota.estado-pendiente {
    background: #fff;
    border-color: ${ofc.inputBorder};
  }

  .dia-celda.marca-inicio {
    box-shadow: 0 0 0 2px ${ofc.secondary};
  }
  .dia-celda.marca-fin {
    box-shadow: 0 0 0 2px ${ofc.violet};
  }
  // "Hoy": anillo adicional (verde azulado) que se suma, sin reemplazar,
  // al color de estado y a los anillos de inicio/fin cuando coinciden.
  .dia-celda.marca-hoy {
    box-shadow: 0 0 0 2px ${ofc.greenDark};
  }
  .dia-celda.marca-inicio.marca-hoy {
    box-shadow: 0 0 0 2px ${ofc.secondary}, 0 0 0 4px ${ofc.greenDark};
  }
  .dia-celda.marca-fin.marca-hoy {
    box-shadow: 0 0 0 2px ${ofc.violet}, 0 0 0 4px ${ofc.greenDark};
  }

  .numero-cuota {
    font-size: 11px;
    font-weight: 700;
    color: ${ofc.bgDark};
    line-height: 1.3;
  }

  .fecha-circulo {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    margin: 2px 0;
    color: #fff;
    flex: none;
  }
  .fecha-circulo.estado-pagada {
    background: ${ofc.primary};
  }
  .fecha-circulo.estado-parcial {
    background: ${ofc.yellow};
    color: ${ofc.textColor};
  }
  .fecha-circulo.estado-sin_abono {
    background: ${ofc.red};
  }
  .fecha-circulo.estado-pendiente {
    background: #fff;
    color: ${ofc.textColor};
    border: 1.5px solid ${ofc.inputBorder};
  }

  .separador {
    width: 80%;
    border-top: 1px dashed ${ofc.inputBorder};
    margin: 2px 0;
  }

  .info-pago {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.25;
    text-align: center;
    width: 100%;
  }

  .info-pago .monto {
    font-size: 11px;
    font-weight: 700;
    color: ${ofc.textColor};
    white-space: nowrap;
  }

  .info-pago .monto-solo {
    font-weight: 600;
    color: ${ofc.bgDark};
  }

  .info-pago .detalle {
    font-size: 11px;
    color: ${ofc.bgDark};
  }

  .estado-sin_abono .info-pago .detalle {
    color: ${ofc.red};
  }

  .marca-label {
    font-size: 11px;
    font-weight: 700;
    margin-top: 2px;
  }

  .marca-inicio .marca-label {
    color: ${ofc.secondary};
  }
  .marca-fin .marca-label {
    color: ${ofc.violet};
  }
  .marca-hoy .marca-label {
    color: ${ofc.greenDark};
  }

  .dia-celda.sin-cuota.domingo {
    background: ${ofc.violet};
  }
  .dia-celda.sin-cuota.domingo .fecha-simple {
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.18);
  }

  .dia-celda.sin-cuota.neutra {
    background: ${ofc.bgLight};
  }
  .dia-celda.sin-cuota.neutra .fecha-simple {
    color: ${ofc.bgDark};
    font-size: 11px;
  }

  .dia-celda.sin-cuota.marca-hoy {
    box-shadow: 0 0 0 2px ${ofc.greenDark};
  }
  .dia-celda.sin-cuota .marca-label {
    margin-top: 1px;
  }
  .dia-celda.sin-cuota.domingo.marca-hoy .marca-label {
    color: #fff;
  }
`;

export default styles;
